/**
 * @flow
 * @relayHash 62befc537288e3a623e6527764b04964
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AiMessageRole = "ASSISTANT" | "SYSTEM" | "USER";
export type AiMessageReceivedSubscriptionVariables = {|
  conversationId: string
|};
export type AiMessageReceivedSubscriptionResponse = {|
  +aiMessageReceived: {|
    +messageId: string,
    +conversationId: string,
    +role: AiMessageRole,
    +content: ?string,
    +tokensUsed: ?number,
    +createdAt: ?any,
  |}
|};
export type AiMessageReceivedSubscription = {|
  variables: AiMessageReceivedSubscriptionVariables,
  response: AiMessageReceivedSubscriptionResponse,
|};
*/


/*
subscription AiMessageReceivedSubscription(
  $conversationId: ID!
) {
  aiMessageReceived(conversationId: $conversationId) {
    messageId
    conversationId
    role
    content
    tokensUsed
    createdAt
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "conversationId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "aiMessageReceived",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "conversationId",
        "variableName": "conversationId"
      }
    ],
    "concreteType": "AiMessage",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "messageId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "conversationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "role",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "content",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "tokensUsed",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "createdAt",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AiMessageReceivedSubscription",
    "type": "Subscription",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AiMessageReceivedSubscription",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "subscription",
    "name": "AiMessageReceivedSubscription",
    "id": null,
    "text": "subscription AiMessageReceivedSubscription(\n  $conversationId: ID!\n) {\n  aiMessageReceived(conversationId: $conversationId) {\n    messageId\n    conversationId\n    role\n    content\n    tokensUsed\n    createdAt\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '28a6c566a520ce5316fe1d0e30a9cef1';
module.exports = node;
